import heroImage from "./images/hero/hero-main.jpeg";
import photoshopIcon from "./images/tools/photoshop.png";
import illustratorIcon from "./images/tools/illustrator.png";
import figmaIcon from "./images/tools/figma.png";
import auditionIcon from "./images/tools/audition.png";
import googleLabsIcon from "./images/tools/googlelabs.png";
import aiToolsIcon from "./images/tools/aitools.png";
import premiereIcon from "./images/tools/primierpro.png";

export const portfolioData = {
  name: 'SHRAVI RANADE',
  tagline: 'GRAPHIC DESIGNER  •  UI / UX DESIGNER  •  AI CREATIVE',
  edition: 'CREATIVE EDITION',
  location: 'PUNE • INDIA',
  established: 'EST. 2026',
  volume: 'VOL. I',
  editionNo: 'EDITION NO. 001',
  website: 'WWW.SHRAVIRANADE.IN',
  websiteTag: "Let's Create Impact",
  hero: {
    badge: 'BREAKING NEWS',
    titleStart: 'Designing',
    titleMid: 'Stories That',
    titleEnd: 'Inspire',
    titleAccent: 'Impact.',
    description:
      'I blend creativity with strategy to craft meaningful visuals, intuitive experiences, and AI-powered designs that leave a lasting impression.',
    cta: 'EXPLORE MY WORK',
    image: heroImage,
  },
  editorNote: {
    heading: 'Creativity is Intelligence Having Fun.',
    body: 'I believe great design is more than aesthetics—it’s about solving problems, telling stories, and creating experiences that connect people.',
    signature: 'Shravi Ranade',
    role: 'FOUNDER & DESIGNER',
  },
  categories: [
    {
      title: 'GRAPHIC DESIGN',
      slug: 'graphic-design',
      subtitle: 'Print, Branding, Editorial\n& Visual Identity',
      image:
        'https://images.unsplash.com/photo-1592966719124-2ca2978ba325?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxtYWdhemluZSUyMGNvdmVyJTIwZGVzaWdufGVufDB8fHx8MTc4Mzk0MzgzN3ww&ixlib=rb-4.1.0&q=85',
      link: 'VIEW PROJECTS',
    },
    {
      title: 'UI / UX DESIGN',
      slug: 'ui-ux',
      subtitle: 'Websites, Mobile Apps\n& Digital Experiences',
      image:
        'https://images.pexels.com/photos/833337/pexels-photo-833337.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      link: 'VIEW PROJECTS',
    },
    {
      title: 'AI CREATIVE',
      slug: 'ai-creative',
      subtitle: 'AI Art, Generative Visuals\n& Experimental Design',
      image:
        'https://images.unsplash.com/photo-1636649830054-cc393e962945?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0',
      link: 'VIEW PROJECTS',
    },
  ],
  tools: {
    title: 'TOOLS I USE',
    subtitle: 'A toolkit that helps me\nturn ideas into reality.',
    link: 'EXPLORE TOOLS',
    items: [
      { name: 'Ps', icon: photoshopIcon, color: '#001E36', text: '#31A8FF' },
      { name: 'Ai', icon: illustratorIcon, color: '#330000', text: '#FF9A00' },
      { name: 'Fg', icon: figmaIcon, color: '#1E1E1E', text: '#F24E1E' },,
      { name: 'Au', icon: auditionIcon, color: '#2E001F', text: '#FF61F6' },
     { name: 'Gp', icon: googleLabsIcon, color: '#000000', text: '#FFFFFF',  },
     { name: 'Md', icon: aiToolsIcon, color: '#F5F1E8', text: '#000000' },
      { name: 'Pr', icon: premiereIcon, color: '#00005B', text: '#9999FF' },
    ],
  },
  about: {
    label: 'ABOUT ME',
    heading: 'Crafting visuals.\nBuilding experiences.\nSolving problems.',
    body: "I'm a multidisciplinary designer passionate about creating designs that are not only beautiful but also purposeful and result-driven.",
    cta: 'MORE ABOUT ME',
  },
  whatIDo: {
    label: 'MY EXPERTISE',
    items: [
      'Brand Identity',
      'Graphic Design',
      'UI / UX Design',
      'AI Creative',
      'Editorial Design',
      'Print Design',
      'Web Design',
    ],
  },
  services: {
    label: 'SERVICES',
    items: [
      'Branding & Identity',
      'Editorial Design',
      'UI / UX Design',
      'AI Visual Creation',
      'Social Media Design',
      'Web Design',
      'Design Consulting',
    ],
    cta: 'ALL SERVICES',
  },
  navigation: ['HOME', 'GRAPHIC DESIGN', 'UI / UX', 'AI CREATIVE', 'TOOLS', 'SERVICES', 'CONTACT'],
  footer: {
    stay: {
      label: 'STAY UPDATED',
      body: 'Subscribe to get updates on my\nlatest work and insights.',
    },
    work: {
      label: "LET'S WORK TOGETHER",
      body: 'Have a project in mind?\nLet’s create something amazing together.',
      cta: 'GET IN TOUCH',
    },
    follow: {
      label: 'FOLLOW ME',
      socials: ['instagram', 'behance', 'linkedin'],
    },
    copyright: '© 2026 Shravi Ranade. All Rights Reserved.',
  },
};
